<script>
  export default {
    props: {
      disableHover: {
        type: Boolean,
        default: false,
      },
      width: {
        type: Number,
        default: 30,
      },
      height: {
        type: Number,
        default: 30,
      },
    },
    computed: {
      viewbox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>

<template>
  <svg
    :class="['icon-truck-moving', { 'no-hover': disableHover }]"
    :width="width"
    :height="height"
    :viewBox="viewbox"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.6154 32.7936C53.6728 32.8687 53.7329 32.9463 53.7952 33.0266C54.6733 34.1584 56.0001 35.8689 56 39.1357V43.1947C56 44.4989 54.9323 45.5601 53.62 45.5601H50.1584C49.92 48.2681 47.6271 50.3999 44.8413 50.3999C42.0556 50.3999 39.7628 48.2681 39.5244 45.5601H31.9077C31.6693 48.2681 29.3764 50.3999 26.5906 50.3999C23.8049 50.3999 21.5121 48.2681 21.2737 45.5601H16.7226C15.9933 45.5601 15.4 45.0053 15.4 44.3234V40.0721C15.4 39.3902 15.9933 38.8354 16.7226 38.8355H37.4444C37.8296 38.8355 38.1106 38.7515 38.2569 38.5926C38.3896 38.4487 38.3764 38.2815 38.3757 38.2744L38.3744 38.2504V26.5748L38.3816 26.5468C38.5358 25.9476 39.0766 25.5292 39.6966 25.5292H40.5641C41.1758 25.5292 41.684 25.523 41.6891 25.5229H47.0092C48.0865 25.5229 49.17 26.1694 50.3215 27.4995C50.8375 28.0955 51.3102 28.9575 51.8106 29.87L51.8106 29.8701L51.8107 29.8702L51.8108 29.8704C52.3212 30.8012 52.8998 31.8563 53.6154 32.7936ZM44.8413 47.0721C45.939 47.0721 46.832 46.1848 46.832 45.0941C46.832 44.0033 45.939 43.116 44.8413 43.116C43.7441 43.116 42.8514 44.0034 42.8514 45.0941C42.8514 46.1848 43.7441 47.0721 44.8413 47.0721ZM51.4092 34.7958C51.3676 34.864 51.2488 34.8935 51.0685 34.882L41.9224 34.8815V27.4662H45.8766C46.9405 27.4662 47.6944 27.9265 48.4788 29.055C49.0005 29.8056 50.3818 32.1689 50.4522 32.2895C50.4995 32.3801 50.548 32.4722 50.597 32.5652L50.6026 32.5759L50.6036 32.5777L50.6036 32.5777C51.0021 33.3348 51.6033 34.477 51.4092 34.7958ZM28.5812 45.0941C28.5812 44.0034 27.6882 43.116 26.5906 43.116C25.4933 43.116 24.6006 44.0033 24.6006 45.0941C24.6006 46.1848 25.4933 47.0721 26.5906 47.0721C27.6882 47.0721 28.5812 46.1848 28.5812 45.0941Z" />
    <path
      d="M17.7405 36.831H24.3374C25.0061 36.831 25.5501 36.3238 25.5501 35.7002V31.1772C25.5501 30.5536 25.0061 30.0464 24.3374 30.0464H17.7405C17.0718 30.0464 16.5278 30.5536 16.5278 31.1772V35.7002C16.5278 36.3238 17.0719 36.831 17.7405 36.831Z" />
    <path
      d="M27.8905 36.831H34.4874C35.1561 36.831 35.7001 36.3238 35.7001 35.7002V31.1772C35.7001 30.5536 35.1561 30.0464 34.4874 30.0464H27.8905C27.2218 30.0464 26.6779 30.5536 26.6779 31.1772V35.7002C26.6779 36.3238 27.2219 36.831 27.8905 36.831Z" />
    <path
      d="M17.7405 27.7846H24.3374C25.0061 27.7846 25.5501 27.2774 25.5501 26.6538V22.1308C25.5501 21.5072 25.0061 21 24.3374 21H17.7405C17.0718 21 16.5278 21.5072 16.5278 22.1308V26.6538C16.5278 27.2774 17.0719 27.7846 17.7405 27.7846Z" />
    <path
      d="M27.8905 27.7846H34.4874C35.1561 27.7846 35.7001 27.2774 35.7001 26.6538V22.1308C35.7001 21.5072 35.1561 21 34.4874 21H27.8905C27.2218 21 26.6779 21.5072 26.6779 22.1308V26.6538C26.6779 27.2774 27.2219 27.7846 27.8905 27.7846Z" />
    <circle cx="19.5" cy="47.5" r="0.5" />
    <circle cx="17" cy="47.5" r="1" />
    <circle cx="13.5" cy="47.5" r="1.5" />
    <circle cx="8.5" cy="47.5" r="2.5" />
  </svg>
</template>
